export default "__VITE_ASSET__CW6OHNUi__"